export default __webpack_public_path__ + "static/logo-8ab40f5139418286034dda2e0c867bd7.png";